import { supabase } from '../../lib/supabase'

export interface PaymentRow {
    id: string
    payment_number: string
    payment_date: string
    direction: 'in' | 'out'
    amount: number
    note: string
    document_id: string
    document_number: string
    document_description: string
    work_item_name: string
    partner_name: string
    reconciled_at: string | null
    reconciled_by: string | null
}

export async function loadPayments(organizationId: string): Promise<PaymentRow[]> {
    const { data, error } = await supabase
        .from('payments')
        .select(`
            id, payment_number, payment_date, direction, amount, note, reconciled_at, reconciled_by,
            payment_allocations(
                financial_document_id,
                financial_documents(
                    document_number, description,
                    work_items(name),
                    partners(name)
                )
            )
        `)
        .eq('organization_id', organizationId)
        .order('payment_date', { ascending: false })

    if (error) throw error

    return (data || []).map((p: any) => {
        const alloc = p.payment_allocations?.[0]
        const doc = alloc?.financial_documents
        return {
            id: p.id,
            payment_number: p.payment_number,
            payment_date: p.payment_date,
            direction: p.direction,
            amount: p.amount,
            note: p.note,
            document_id: alloc?.financial_document_id,
            document_number: doc?.document_number || '',
            document_description: doc?.description || p.note || 'Không rõ',
            work_item_name: doc?.work_items?.name || 'Chi phí chung',
            partner_name: doc?.partners?.name || 'Chưa có đối tác',
            reconciled_at: p.reconciled_at,
            reconciled_by: p.reconciled_by
        }
    })
}

export async function createDirectPayment(input: {
    organizationId: string,
    type: 'income' | 'expense',
    description: string,
    amount: number,
    categoryId?: string,
    partnerId?: string,
    workItemId?: string,
    date: string,
    notes?: string,
    cashAccountId?: string
}) {
    const { data, error } = await supabase.rpc('create_direct_payment', {
        p_organization_id: input.organizationId,
        p_document_type: input.type,
        p_description: input.description,
        p_amount: input.amount,
        p_category_id: input.categoryId || null,
        p_partner_id: input.partnerId || null,
        p_work_item_id: input.workItemId || null,
        p_date: input.date,
        p_notes: input.notes || null,
        p_cash_account_id: input.cashAccountId || null
    })
    if (error) throw error
    return data
}
